import { TextField } from "@platform/design-system";
import { Autocomplete } from "@mui/material";

import { useFetchCarrierOptionsQuery } from "../../../hooks/useBbe";

import type { TextFieldProps } from "@platform/design-system";

type CarrierOption = { label: string; value: string };

type CarrierSelectProps = {
  textFieldProps?: TextFieldProps;
  value: CarrierOption | null;
  onChange: (value: CarrierOption | null) => void;
  disabled?: boolean;
  filter?: { carrierId: string };
};

export const CarrierSelect: React.FC<CarrierSelectProps> = ({
  textFieldProps,
  value,
  onChange,
  disabled,
  filter,
}) => {
  const carriers = useFetchCarrierOptionsQuery();
  const filteredCarriers = filter?.carrierId
    ? (carriers.data?.filter((carrier) => carrier.value !== filter.carrierId) ??
      [])
    : (carriers.data ?? []);

  return (
    <Autocomplete
      disableClearable
      data-testid="carrier-autocomplete"
      options={filteredCarriers}
      renderInput={(params) => (
        <TextField {...params} size="sm" label="Carrier" {...textFieldProps} />
      )}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      loading={carriers?.isLoading}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      disabled={disabled}
    />
  );
};
